import { render, staticRenderFns } from "./BaseInputNumber2.vue?vue&type=template&id=296ef3d6&scoped=true"
import script from "./BaseInputNumber2.vue?vue&type=script&lang=js"
export * from "./BaseInputNumber2.vue?vue&type=script&lang=js"
import style0 from "./BaseInputNumber2.vue?vue&type=style&index=0&id=296ef3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ef3d6",
  null
  
)

export default component.exports